import RoutesMap from "route_control/RouteControl";
import { toast } from "react-toastify";
import showAccessDeniedAlert from "./accessDenied";
import SessionManager from "./sessionManager";

const addUpdateHandler = (data) => {

    const { res, action, navigate, success_toast, wrong_toast, navigate_route, spinner, toggle } = data;

    // Customer portal APIs return HTTP 200 with an application responseCode
    // (e.g. 417 / 406) on failure — never treat those as success.
    const responseCode = res?.data?.responseCode;
    if (res?.status === 200 && responseCode !== undefined && responseCode !== 200) {
        toast.error(res?.data?.responseMessage || wrong_toast, { position: "bottom-right", closeOnClick: true });
        spinner(false);
        return;
    }

    if (res?.status === 201) {
        toast.success(success_toast, { position: "bottom-right", closeOnClick: true });
        spinner(false);
        action?.resetForm()
        if (navigate_route === '') {
            toggle();
        } else {
            setTimeout(() => {
                navigate(navigate_route);
            }, 1500);
        }
    } else if (res?.status === 200) {
        toast.success(success_toast, { position: "bottom-right", closeOnClick: true });
        spinner(false);
        action?.resetForm()
        if (navigate_route === '') {
            toggle();
        } else {
            setTimeout(() => {
                navigate(navigate_route);
            }, 1500);
        }
    } else if (res?.status === 401) {
        SessionManager.clearAll();
        navigate(RoutesMap.LOGIN.path);
    } else if (res?.status === 400) {
        toast.error(res?.data?.message, { position: "bottom-right", closeOnClick: true });
        spinner(false);
    } else if (res?.status === 403) {
        showAccessDeniedAlert(navigate)
        spinner(false);
    } else {
        toast.error(wrong_toast, { position: "bottom-right", closeOnClick: true });
        spinner(false);

    }
};

export default addUpdateHandler;